/**
 * Generic TypeGuard to verify that keys are defined in a specified object.
 */
export function has_required_keys(object, ...keys) {
    return keys.every(key => !!object[key]);
}
//# sourceMappingURL=HasRequiredKeys.js.map